import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('auth0'),
  avatarPath: avatars.auth0,
  logoPath: logos.auth0
});
